import { render, staticRenderFns } from "./submitInformationDetail.vue?vue&type=template&id=2e921715&scoped=true"
import script from "./submitInformationDetail.vue?vue&type=script&lang=js"
export * from "./submitInformationDetail.vue?vue&type=script&lang=js"
import style0 from "./submitInformationDetail.vue?vue&type=style&index=0&id=2e921715&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e921715",
  null
  
)

export default component.exports